<template>
    <div class="monitoring-list">
        <ProjectGroupCard v-for="projectGroup in projectGroups"
                          :key="projectGroup.id"
                          :project="projectGroup"
                          @project-edit="handleProjectEdit"
                          @project-delete="handleProjectDelete"
        />
    </div>
</template>

<script setup lang="ts">
    import type { ProjectGroupDto } from '~/src/shared/types/generated'
    import ProjectGroupCard from '~/src/features/monitoring/components/ProjectGroupCard/ProjectGroupCard.vue'

    defineProps<{
        projectGroups: ProjectGroupDto[]
        isLoading: boolean
    }>()

    const handleProjectEdit = (_id: number) => {
        // useModalStore().open(MonitoringEditProject, {
        //     id: _id
        // })
    }
    const handleProjectDelete = async (id: number) => {
        await monitoringStore.deleteProjectRequest(id)
    }
</script>

<style lang="scss" scoped>
    .monitoring-list {
        display: flex;
        flex-flow: column;
        gap: 24px 0;
        width: 100%;

        @include respond-to(mobile) {
            gap: 16px 0;
        }
    }
</style>
